import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Env } from '../../env/env';

@Injectable({
  providedIn: 'root'
})
export class AdApiService {
private baseUrl: string = `${Env.baseUrl}v1/ad-delivery`;

  constructor(private http: HttpClient) {}

  public getDeliver(adData: any) {
    return this.http.post<any>(`${this.baseUrl}/deliver/multiple`, adData);
  }
}
